var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#2E37A4",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1852 17.3203C19.5974 17.3203 17.4829 19.4244 17.4829 21.9994C17.4829 24.5742 19.5974 26.6782 22.1852 26.6782C24.7727 26.6782 26.8872 24.5742 26.8872 21.9994C26.8872 19.4244 24.7727 17.3203 22.1852 17.3203ZM22.1852 18.8638C23.9344 18.8638 25.3358 20.2584 25.3358 21.9992C25.3358 23.7397 23.9344 25.1342 22.1852 25.1342C20.4358 25.1342 19.0343 23.7397 19.0343 21.9992C19.0343 20.2584 20.4358 18.8638 22.1852 18.8638Z",
    fill: "#00D3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1861 14C16.7627 14.0002 11.7582 16.9135 9.0996 21.6168C8.96673 21.8515 8.96694 22.1383 9.09938 22.3733C11.7555 27.0806 16.7606 29.9972 22.1859 29.9995C27.6092 29.9975 32.614 27.0823 35.271 22.3775C35.4036 22.1428 35.4036 21.8559 35.271 21.6212C32.614 16.9165 27.6091 14.0028 22.1861 14ZM22.1859 15.5435C26.9048 15.5453 31.2636 18.0016 33.6962 21.9999C31.2632 25.9978 26.9048 28.4535 22.1864 28.4558C17.466 28.454 13.1059 25.996 10.6733 21.9955C13.1078 17.9989 17.4675 15.5435 22.1859 15.5435Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepIcon05);
export default __webpack_public_path__ + "static/media/dep-icon-05.e7457ae5f3caef80eb810ed0a77e231c.svg";
export { ForwardRef as ReactComponent };